export function useFitterAPI() {
  const { errors, request } = useRequestV2();

  async function getFitters() {
    const url = 'V3/Fitter/GetFitters';
    const response = await request<FitterResponseDTO[]>(url, {
      method: 'GET'
    });

    return response;
  }

  return {
    errors,
    getFitters
  };
}
